import React, { useState,useEffect } from 'react'
import { components, useServices, useTranslation } from 'cng-web-lib'
import Namespace from '../../../../constants/locale/Namespace'
import { Box, Grid, Paper } from '@material-ui/core'
import { FileForUserGetUserDetails } from 'src/common/FileForUserCommon'
import EhblManifestKeys from 'src/constants/locale/key/EhblManifest'
import EhblManifestApiUrls from 'src/apiUrls/EhblManifestApiUrls'
import ErrorMessageSection from 'src/views/common/ErrorMessageSection'
import { getHouseBillCSVTemplate } from '../../common'

const {
  button: { CngButton },
  dropzone: { CngFileUpload },
  CngDialog
} = components

function ManifestCSVUploadDialog(props) {
  const { onClose, open, showNotification } = props

  const [files, setFiles] = useState([])
  const [errorMessages, setErrorMessages] = useState([])
  const [loading, setLoading] = useState(false)
  const { securedSendRequest } = useServices()
  const { translate } = useTranslation(Namespace.EHBL_MANIFEST)
  const translatedTextsObject = makeTranslatedTextsObject()

  const [csvBlob, setCsvBlob] = useState(null);  

  function makeTranslatedTextsObject() {
    let saveButton = translate(
      Namespace.EHBL_MANIFEST,
      EhblManifestKeys.SAVE_BUTTON
    )

    let dialogTitle = translate(
      Namespace.EHBL_MANIFEST,
      EhblManifestKeys.UPLOAD_CSV_DILAOG_TITLE
    )

    let successMsg = translate(
      Namespace.EHBL_MANIFEST,
      EhblManifestKeys.UPLOAD_CSV_SUCCESS_MSG
    )

    let errorMsg = translate(
      Namespace.EHBL_MANIFEST,
      EhblManifestKeys.UPLOAD_CSV_ERROR_MSG
    )

    let fileEmptyMsg = translate(
      Namespace.EHBL_MANIFEST,
      EhblManifestKeys.UPLOAD_CSV_FILE_EMPTY_ERROR_MSG
    )

    let discardButton = translate(
      Namespace.EHBL_MANIFEST,
      EhblManifestKeys.DISCARD_BUTTON
    )

    let downloadTemplateCSV = translate(
      Namespace.EHBL_MANIFEST,
      EhblManifestKeys.DOWNLOAD_TEMPLATE_CSV
    )

    return { 
      saveButton,
      dialogTitle, 
      successMsg, 
      errorMsg, 
      discardButton,
      fileEmptyMsg,
      downloadTemplateCSV
    }
  }

  useEffect(() => {
    setFiles([])
    setErrorMessages([])

    const loadCsvBlob = async () => {
      const res = await fetch(`${process.env.PUBLIC_URL}/csv/eHBL_House_Bill_Sample_Upload_V2.csv`);
      if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);
      const csvFileBlob = await res.blob();
      setCsvBlob(csvFileBlob);
    };

    loadCsvBlob().catch(console.error);    

  }, [open]);

  const downloadCSVTemplateV2File = () => {
    
    const blob = new Blob([csvBlob], { type: "text/csv" })
    const element = document.createElement("a");
    element.href = window.URL.createObjectURL(blob)
    element.download = "eHBL_House_Bill_Sample_Upload_V2.csv";
    document.body.appendChild(element);
    element.click();
    element.parentNode.removeChild(element);
  }

  function handleUploadShipment() {

    if(files.length>0){
      try {
        setLoading(true)

        let fileForUserDetails = FileForUserGetUserDetails();
        const formData = new FormData()

        formData.append('file', files[0].file)
        if (fileForUserDetails != null && fileForUserDetails != undefined) {
          formData.append("fileForUserDetails", JSON.stringify(fileForUserDetails))
        } else {
          formData.append("fileForUserDetails", "{}")
        }

        securedSendRequest.execute(
          'POST',
          EhblManifestApiUrls.UPLOAD,
          formData,
          (response) => {
            console.log(response)
            if (response.status === 200) {
              if (response.data) {
                const errorMessages = response.data.errorMessages

                if (errorMessages) {
                  setErrorMessages(errorMessages)
                  setFiles([])
                }
              }else{
                showNotification('success', translatedTextsObject.successMsg)
                onClose()
                open.tableRef.current.performRefresh()
              }
            }
          },
          () => {
            showNotification('error', translatedTextsObject.errorMsg)
            setFiles([])
          },
          () => setLoading(false)
        )
      } catch (error) {
        console.log(error)
      }
    }else{
      showNotification('error', translatedTextsObject.fileEmptyMsg)
    }
  }

  return (
    <CngDialog
      dialogTitle={translatedTextsObject.dialogTitle}
      dialogContent={
        <Paper variant='outlined'>
          <Box padding={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CngFileUpload
                  accept={['.csv']}
                  files={files}
                  maxFiles={1}
                  maxSize={5.3e+7}
                  onFileSelect={(file) => setFiles(file)}
                  showFormFields={false}
                  moreActions={[
                    {
                      action: 'remove',
                      name: 'Remove',
                      icon: ['fal', 'trash']
                    }
                  ]}
                  onDropRejected={(errorMessages) => showNotification('error', errorMessages)}
                />
              </Grid>

              <ErrorMessageSection errorMessages={errorMessages} />

              <Grid item xs={12}>
                <Grid container justify='flex-end' spacing={2}>
                  <Grid item xs='auto'>
                    <CngButton size='medium' variant='outlined' onClick={downloadCSVTemplateV2File}>
                      {translatedTextsObject.downloadTemplateCSV}
                    </CngButton>
                  </Grid>
                </Grid>
              </Grid>

            </Grid>
          </Box>
        </Paper>
      }
      dialogAction={
        <>
          <CngButton color='secondary' disabled={loading} onClick={onClose}>
            {translatedTextsObject.discardButton}
          </CngButton>
          <CngButton
            color='primary'
            disabled={loading}
            onClick={handleUploadShipment}
            shouldShowProgress={loading}
          >
            {translatedTextsObject.saveButton}
          </CngButton>
        </>
      }
      fullWidth
      maxWidth='lg'
      open={open.open}
      onClose={onClose}
      shouldShowCloseButton
    />
  )
}

export default ManifestCSVUploadDialog
